export const paymentMethods = {
  SEPA: 'SEPA',
  TRANSFER: 'TRANSFER',
};

export const paymentMethodSteps = {
  SEPA_MANDATE: 'SEPA_MANDATE',
  SEPA_MANDATE_CONFIRM: 'SEPA_MANDATE_CONFIRM',
  SEPA_BRANCH_ASSIGNMENT: 'SEPA_BRANCH_ASSIGNMENT',
  SEPA_COMPLETED: 'SEPA_COMPLETED',
};

export const sepaMandateValid = sepaMandate => {
  const check = { ...sepaMandate };

  delete check.id;
  delete check.alternateAccountHolder;

  return (
    Object.keys(check)
      .map(key => check[key])
      .filter(value => value.length === 0).length === 0
  );
};

export const insertSpaceBetween = (value = '', spaceAt = 4) => {
  const spacedString = [];
  const stripped = value.replace(/\s/g, '');

  [...stripped].forEach((char, idx) => {
    spacedString.push(char);

    if (idx !== 0 && (idx + 1) % spaceAt === 0) {
      spacedString.push(' ');
    }
  });

  return spacedString.join('').trim();
};
